import { render, staticRenderFns } from "./thank-you.vue?vue&type=template&id=8a8c4ab8&"
import script from "./thank-you.vue?vue&type=script&lang=js&"
export * from "./thank-you.vue?vue&type=script&lang=js&"
import style0 from "./thank-you.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "thank-you.vue"
export default component.exports